document.addEventListener("DOMContentLoaded", (e) => {
  let langPopUp = document.querySelector(".fn-0008-lang");
  const btn = document.querySelector(".fn-0008-lang-btn");
  const popupClose = document.querySelectorAll(
    ".fn-0008-lang h3 svg, .fn-0008-lang-overlay",
  );

  //Open Mobile Lang popup
  btn.addEventListener("click", () => {
    langPopUp.classList.add("open");
  });

  //Close Mobile Lang popup
  popupClose.forEach((c) => {
    c.addEventListener("click", () => {
      langPopUp.classList.remove("open");
    });
  });

  langPopUp.addEventListener("click", () => {
    langPopUp.classList.toggle("open");
  });

  //Desktop
  const menu = document.querySelector(".fn-0008-lang-desktop-btn");
  const submenu = document.querySelector(".fn-0008-lang-desktop-popup");

  menu.addEventListener("focusin", () => showSubMenu(menu));
  menu.addEventListener("mouseover", () => showSubMenu(menu));
  menu.addEventListener("touchstart", () => showSubMenu(menu));

  menu.addEventListener("mouseleave", () => hideSubMenu(menu));

  submenu.addEventListener("mouseleave", () => hideSubMenu(menu));
  submenu.addEventListener("focusout", () => hideSubMenu(menu));
});

function showSubMenu(menu) {
  menu.classList.add("nav-hover");
}

function hideSubMenu(menu) {
  menu.classList.remove("nav-hover");
}
